module.exports = __webpack_public_path__ + "images/days/day06.gif";